import { LoadingScreen } from './LoadingScreen';
import { useLoadingContext } from '@features/contexts/LoadingProvider';

export const GlobalLoading = () => {
    const { loading } = useLoadingContext();
    return <LoadingScreen active={loading} />;
};
